// Constants for the AI Tutor Awards 2026 review panel.
// Rubric content lives on a template tutor (no longer hardcoded here) and
// is cloned onto each reviewed tutor on first open via createAssessmentTool
// with copyAssessmentToolId.

// Org whose JWT is allowed to see the reviewer flow buttons.
export const REVIEWER_ELIGIBLE_ORG_ID = "372940110473207511";

// Source AI tutor that has the panel SCORE_BASED_RUBRIC manually configured.
// We pass this as `copyAssessmentToolId` to createAssessmentTool so the BE
// clones the rubric (assessment_tool wrapper + criteria + descriptors) onto
// the target tutor.
export const RUBRIC_SOURCE_ASSESSMENT_ID = "378305329571573585";
